import React, { useState } from 'react';
import { User, LogOut, Settings, Trash2, Users, Palette } from 'lucide-react';
import { signOut, deleteAccount } from '../lib/auth';
import { UserSettings } from './UserSettings';
import UserCharacters from './UserCharacters';
import { ThemeSettings } from './ThemeSettings';

interface Props {
  user: {
    email: string;
  };
}

export default function UserMenu({ user }: Props) {
  const [showMenu, setShowMenu] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showCharacters, setShowCharacters] = useState(false);
  const [showThemeSettings, setShowThemeSettings] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
      alert('Une erreur est survenue lors de la déconnexion');
    }
  };

  const handleDeleteAccount = async () => {
    const confirm = window.confirm(
      'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.'
    );

    if (!confirm) return;

    try {
      await deleteAccount();
    } catch (error) {
      console.error('Error deleting account:', error);
      alert('Une erreur est survenue lors de la suppression du compte');
    }
  };

  return (
    <>
      <div className="relative">
        <button
          onClick={() => setShowMenu(!showMenu)}
          className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center">
            <User className="w-5 h-5 text-purple-600" />
          </div>
          <span className="text-sm font-medium text-gray-700">{user.email}</span>
        </button>

        {showMenu && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 z-50">
            <button
              onClick={() => {
                setShowMenu(false);
                setShowThemeSettings(true);
              }}
              className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
            >
              <Palette className="w-4 h-4" />
              Thème
            </button>
            <button
              onClick={() => {
                setShowMenu(false);
                setShowCharacters(true);
              }}
              className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
            >
              <Users className="w-4 h-4" />
              Mes personnages
            </button>
            <button
              onClick={() => {
                setShowMenu(false);
                setShowSettings(true);
              }}
              className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
            >
              <Settings className="w-4 h-4" />
              Paramètres
            </button>
            <button
              onClick={handleSignOut}
              className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
            >
              <LogOut className="w-4 h-4" />
              Déconnexion
            </button>
            <hr className="my-1" />
            <button
              onClick={handleDeleteAccount}
              className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
            >
              <Trash2 className="w-4 h-4" />
              Supprimer le compte
            </button>
          </div>
        )}
      </div>

      {showSettings && (
        <UserSettings onClose={() => setShowSettings(false)} />
      )}

      {showCharacters && (
        <UserCharacters onClose={() => setShowCharacters(false)} />
      )}

      {showThemeSettings && (
        <ThemeSettings onClose={() => setShowThemeSettings(false)} />
      )}
    </>
  );
}